import barrierImage from '../../../../../../../public/img/Barriers.png'
import catylystImage from '../../../../../../../public/img/Catalyst.png'
import treasureImage from '../../../../../../../public/img/Treasure.png'
import vulnerabilityImage from '../../../../../../../public/img/blindspot.png'


export const TABLE_HEADINGS = [{ title: "Category", className: "" }, { title: "Behavior", className: "" },
{ title: "All But Self", className: "" }, { title: "Self", className: "" }
]

export const TABLE_HEADINGS_FOR_ARCTRYX = [{ title: "Category", className: "" }, { title: "Behavior", className: "" },
]

export const CLASSNAMES_BASED_ON_CARD = {
    knownStrength: "",
    unknownStrength: "gray",
    knownImprovementAreas: "gray",
    unknownImprovementAreas: ""
}

export const CARD_IMAGE = {
    knownStrength: catylystImage,
    unknownStrength:barrierImage ,
    knownImprovementAreas:treasureImage ,
    unknownImprovementAreas: vulnerabilityImage
}